import './ExpandableQuestionCard.scss';

import React from 'react';

import { useAtom } from 'jotai';

import { translate } from '~l10n/client';
import { SmallButton } from '~shared/components/buttons';
import { useQuestionGenerator } from '~teacher/components/QuizEditor/GenerateQuestionDialog/context';
import { addedQuestionSetAtom } from '~teacher/components/QuizEditor/GenerateQuestionDialog/GenerateQuestionStep2';
import { QuestionDetails } from '~teacher/components/QuizEditor/GenerateQuestionDialog/QuestionDetails';

export const ExpandableQuestionCard = ({
  question,
  addQuestion,
}: {
  question: ReturnType<
    typeof useQuestionGenerator
  >['data']['questions'][number];
  addQuestion: () => void;
}) => {
  const [addedQuestionSet] = useAtom(addedQuestionSetAtom.valueAtom);
  const isQuestionAdded = addedQuestionSet.has(question.questionId);

  return (
    <div className="question-card">
      <div className="flex">
        <div className="flex-grow">
          <QuestionDetails
            questionType={question.questionType}
            questionText={question.questionText}
            answers={question.answers}
            explanation={question.explanation}
          />
        </div>
        <div className="flex justify-end pt-5 flex-shrink-0 flex-grow-0">
          <div className="flex pr-2">
            <div>
              <SmallButton
                appearance="primary"
                isDisabled={isQuestionAdded}
                onClick={addQuestion}
              >
                {translate('Add')}
              </SmallButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
